import React from "react";
import PageHeaderUserNotifications from "./PageHeaderUserNotifications";
import PageHeaderUserWallet from "./PageHeaderUserWallet";
import PageHeaderUserInfo from "./PageHeaderUserInfo";
import PageHeaderChecklistHandler from "./PageHeaderChecklistHandler";

const PageHeaderUser = () => {
  return (
    <nav className="page-header__user">
      <PageHeaderChecklistHandler />
      <PageHeaderUserWallet />
      <PageHeaderUserNotifications />
      <PageHeaderUserInfo />
    </nav>
  );
};

export default PageHeaderUser;
